(function () {

    "use strict";

    angular.module("sphforms.app")
        .constant('LANGUAGES', {
            predefinido: 'INGLES',
            languages: [
                {
                    language: 'ESPAÑOL',
                    locales: ['es', 'es_es', 'es-es'],
                    locale: 'es'
                },
                {
                    language: 'INGLES',
                    locales: ['en', 'en_gb', 'en-gb', 'en-us', 'en_us'],
                    locale: 'en'
                },
                {
                    language: 'CATALAN',
                    locales: ['ca', 'ca_es', 'ca-es'],
                    locale: 'ca'
                }
            ]
        }).constant('CLASSDOCUMENT', {
            'PDF': 'fa fa-file-pdf-o',
            'VIDEO': 'fa fa-file-video-o',
            'AUDIO': 'fa fa-file-audio-o',
            'GENERAL': 'fa fa-file-o',
            'CODE': 'fa fa-file-code-o',
            'PPT': 'icon-ppt',
            'EXCEL': 'icon-excel',
            'IMAGE': 'fa fa-file-image-o',
            'WORD': 'icon-word',
            'VISIO': 'icon-visio',
            'TEXT': 'fa fa-file-text-o',
            'FILES': 'fa fa-files-o',
            'ZIP': 'fa fa-file-archive-o',
            'EMAIL': 'fa fa-envelope-o'
        }).constant('FORMATOSFICHEROS', {
            'audio': ['.mp3', '.ogg', '.wav', '.midi', '.ogm', '.wma'],
            'video': ['.avi', '.divx', '.mov', '.mp4', '.mpeg', '.mpg', '.qt', '.rpm', '.wmv'],
            'code': ['.js', '.cs', '.vb', '.html', '.py', '.bat', '.css', '.xml', '.sql'],
            'comprimidos': ['.rar', '.zip', '.lzh', '.cab'],
            'imagenes': ['.bmp', '.gif', '.ico', '.jpe', '.jpeg', '.jpg', '.psd', '.psp', '.rgb', '.tif', '.tiff'],
            'text': ['.txt'],
            'word': ['.doc', '.docx', '.dotx', '.dot', '.rtf', '.docm', '.dotm'],
            'excel': ['.xlsx', '.xlsm', '.xlsb', '.xltx', '.xltm', '.xls', '.xlt'],
            'powerpoint': ['.pptx', '.pptm', '.potx', '.potm', '.ppsx', '.ppam', '.ppt', '.ppsm'],
            'visio': ['.vsd', '.vsdm', '.vsdx'],
            'pdf': ['.pdf'],
            'email': ['.eml', '.msg']
        }).constant('TYPEVIEWERS', {
            gd: 0,
            office: 1,
            email: 2,
            noviewer: 3
        }).constant('SOLPHEO', {
            fileContainers: [
                {
                    name: "aplicaciones",
                    id: 1
                },
                {
                    name: "manuales",
                    id: 10
                }
            ],
            workFlows: [
                {
                    id: 2019,
                    name: "Firma",
                    customForm: "manual",
                    customActivity: "Aprobacion",
                    activities: [
                        {
                            name: "A firmar toca"
                        }
                    ]
                },
                {
                    id: 10,
                    name: "Alta proveedor Homologacion",
                    customForm: "Alta",
                    customActivity: "Homologar",
                    activities: [
                        {
                            name: "Pagar"
                        }
                    ]
                },
                {
                    id: 10,
                    name: "Alta proveedor Homologacion",
                    customForm: "AltaAceptar",
                    customActivity: "Homologar",
                    activities: [
                        {
                            name: "Aceptar políticas"
                        }
                    ]
                },
                {
                    id: 14,
                    name: "Homologar producto",
                    customForm: "Producto",
                    customActivity: "Homologar",
                    activities: [
                        {
                            name: "Datos producto"
                        },
                        {
                            name: "Idoneidad"
                        },
                        {
                            name: "Conformidad"
                        },
                        {
                            name: "Alergenos"
                        },
                        {
                            name: "Analisis"
                        },
                        {
                            name: "OGM"
                        },
                        {
                            name: "Visar Datos producto"
                        },
                        {
                            name: "Visar Idoneidad"
                        },
                        {
                            name: "Visar Conformidad"
                        },
                        {
                            name: "Visar Alergenos"
                        },
                        {
                            name: "Visar Analisis"
                        },
                        {
                            name: "Visar OGM"
                        },
                        {
                            name: "Validar datos producto"
                        },
                        {
                            name: "Validar Idoneidad"
                        },
                        {
                            name: "Validar Conformidad"
                        },
                        {
                            name: "Validar Alergenos"
                        },
                        {
                            name: "Validar Analisis"
                        },
                        {
                            name: "Validar OGM"
                        },
                        {
                            name: "Volver visar datos producto"
                        },
                        {
                            name: "Volver visar Idoneidad"
                        },
                        {
                            name: "Volver visar Conformidad"
                        },
                        {
                            name: "Volver visar Alergenos"
                        },
                        {
                            name: "Volver visar Analisis"
                        },
                        {
                            name: "Volver visar OGM"
                        },
                        {
                            name: "Datos producto homologados"
                        },
                        {
                            name: "Analisis homologados"
                        },
                        {
                            name: "Idoneidad homologados"
                        },
                        {
                            name: "Conformidad homologados"
                        },
                        {
                            name: "Alergenos homologados"
                        },
                        {
                            name: "OGM homologados"
                        }
                    ]
                },
                {
                    id: 15,
                    name: "Homologar planta",
                    customForm: "Planta",
                    customActivity: "Homologar",
                    activities: [
                        {
                            name: "Datos planta"
                        },
                        {
                            name: "Seguridad alimentaria"
                        },
                        {
                            name: "Conducta etica"
                        },
                        {
                            name: "Certificados"
                        },
                        {
                            name: "Visar Datos planta"
                        },
                        {
                            name: "Visar Seguridad alimentaria"
                        },
                        {
                            name: "Visar Conducta etica"
                        },
                        {
                            name: "Visar Certificados"
                        },
                        {
                            name: "Validar datos planta"
                        },
                        {
                            name: "Validar Seguridad alimentaria"
                        },
                        {
                            name: "Validar Conducta etica"
                        },
                        {
                            name: "Validar Certificados"
                        },
                        {
                            name: "Volver visar Datos planta"
                        },
                        {
                            name: "Volver visar Seguridad alimentaria"
                        },
                        {
                            name: "Volver visar conducta etica"
                        },
                        {
                            name: "Volver visar Certificados"
                        },
                        {
                            name: "Datos planta homologados"
                        },
                        {
                            name: "Seguridad alimentaria homologados"
                        },
                        {
                            name: "Conducta etica homologados"
                        },
                        {
                            name: "Certificados homologados"
                        }
                    ]
                },
                {
                    id: 16,
                    name: "Homologar Proveedor",
                    customForm: "Proveedor",
                    customActivity: "Homologar",
                    activities: [
                        {
                            name: "Datos comerciales"
                        },
                        {
                            name: "Visar Datos comerciales"
                        },
                        {
                            name: "Validar datos comerciales"
                        },
                        {
                            name: " Volver visar Datos comerciales"
                        },
                        {
                            name: "Datos comerciales homologados"
                        }
                    ]
                }
            ]
        })
        .constant('TENANT', {
            URL: 'licenciaskyocera'
        })
        .constant('URL', {
            URL: 'https://licenciaskyocera.eu01.solpheosuite.com'
        });
}());